import React, { useState } from 'react';
import styles from './FloatingHelpButton.module.css';
import HelpModal from './HelpModal';

export default function FloatingHelpButton() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className={styles.floatingContainer}>
        <button
          className={styles.helpButton}
          onClick={handleClick}
          onMouseEnter={() => setIsExpanded(true)}
          onMouseLeave={() => setIsExpanded(false)}
          aria-label="Get Help"
        >
          <div className={styles.iconContainer}>
            {/* Customer Service Icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path 
                d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
              <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
              <path 
                d="M23 21v-2a4 4 0 0 0-3-3.87" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
              <path 
                d="M16 3.13a4 4 0 0 1 0 7.75" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
          
          <div className={`${styles.helpText} ${isExpanded ? styles.expanded : ''}`}>
            <span className={styles.helpTitle}>Need Help?</span>
            <span className={styles.helpSubtitle}>Contact Support</span>
          </div>
        </button>
      </div>

      {/* Help Modal */}
      <HelpModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
}
